import { render, staticRenderFns } from "./FamilyActivityHistory.vue?vue&type=template&id=770402c6&scoped=true&"
import script from "./FamilyActivityHistory.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770402c6",
  null
  
)

export default component.exports